import React, { useState, useEffect } from 'react';
import './TransportationModal.css';

interface TransportationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (types: string[]) => void;
  currentTypes: string[];
}

const TransportationModal: React.FC<TransportationModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentTypes
}) => {
  const [types, setTypes] = useState<string[]>(currentTypes);
  const [newType, setNewType] = useState('');

  useEffect(() => {
    setTypes(currentTypes);
  }, [currentTypes, isOpen]);

  const handleAddType = () => {
    if (newType.trim() && !types.includes(newType.trim())) {
      setTypes([...types, newType.trim()]);
      setNewType('');
    } else if (types.includes(newType.trim())) {
      alert('This type already exists!');
    }
  };

  const handleRemoveType = (typeToRemove: string) => {
    if (types.length <= 1) {
      alert('You must have at least one transportation type!');
      return;
    }
    setTypes(types.filter(t => t !== typeToRemove));
  };

  const handleSave = () => {
    onSave(types);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="transportation-modal-overlay" onClick={onClose}>
      <div className="transportation-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="transportation-modal-header">
          <h5>Manage Transportation Types</h5>
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="transportation-modal-body">
          <div className="add-type-section">
            <h6>Add New Type</h6>
            <div className="add-type-form">
              <input
                type="text"
                value={newType}
                onChange={(e) => setNewType(e.target.value)}
                placeholder="Enter new transportation type..."
                onKeyPress={(e) => e.key === 'Enter' && handleAddType()}
                className="type-input"
              />
              <button onClick={handleAddType} className="add-type-btn">Add</button>
            </div>
          </div>

          <hr />

          <div className="types-list-section">
            <h6>Current Types</h6>
            <div className="types-list">
              {types.map((type, index) => (
                <div key={index} className="type-item">
                  <span className="type-name">{type}</span>
                  <button 
                    onClick={() => handleRemoveType(type)} 
                    className="remove-type-btn"
                    disabled={types.length <= 1}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="modal-footer">
            <button onClick={handleSave} className="save-types-btn">Save Changes</button>
            <button onClick={onClose} className="cancel-types-btn">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportationModal;






